import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const baseUrl = window.wmBaseUrl;
const baseEndpointUrl = window.wmBaseEndpointUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: 'https://lk.seafoodexporussia.com/'+baseEndpointUrl
})

const AppAPI = createApi({
  reducerPath: "AppAPI",
  baseQuery,
  endpoints: (build) => ({
    getTableData: build.query<any, { filter?: any, page?: number }>({
      query: ({ filter, page }) => ({
        url: "/company-rest/data",
        method: "POST",
        body: filter,
        params: { page }
      })
    }),
    getCategories: build.query({
      query: () => "/filter/category-list"
    }),
    getActivities: build.query({
      query: () => "/filter/activity-list"
    }),
    getCountries: build.query({
      query: () => "/filter/country-list"
    }),
  })
})

export default AppAPI